export class ChatMessageToolbar implements ng.IComponentController {
    // language=HTML
    static template = `<div class="chat-message-toolbar" is-uib>
    <div class="btn-group btn-group-{{$ctrl.size}}">
        <label class="btn btn-default" uib-tooltip="Quote message" tooltip-placement="$ctrl.tooltipPlacement" ng-click="$ctrl.click('quote')"><i class="fa fa-quote-right"></i></label>
        <label ng-if="$ctrl.isEditable" class="btn btn-default" uib-tooltip="Edit message" tooltip-placement="$ctrl.tooltipPlacement" ng-click="$ctrl.click('edit')"><i class="fa fa-edit"></i></label>
    </div>
</div>
`;
    private size?: 'xs' | 'sm' | 'lg';
    private tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
    private onClick?: Function;
    private isEditable?: boolean;

    $onInit() {
        this.size = this.size ?? 'xs';
        this.tooltipPlacement = this.tooltipPlacement ?? 'top';
    }

    click(buttonName: 'quote' | 'edit') {
        this.onClick && this.onClick({ button: buttonName });
    }
}

angular.module('tradersyard').component('tyChatMessageToolbar', {
    template: ChatMessageToolbar.template,
    controller: ChatMessageToolbar,
    transclude: true,
    bindings: {
        size: '@?', // 'xs', 'sm', 'lg', undefined
        tooltipPlacement: '@?',
        onClick: '&',
        isEditable: '<',
    },
});
